module.exports = __webpack_public_path__ + "img/product-24.5546cf21.jpg";